import { render } from "./ImportCustomRules.vue?vue&type=template&id=56c3eb51"
import script from "./ImportCustomRules.vue?vue&type=script&lang=js"
export * from "./ImportCustomRules.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__